<template>

<div class="section-container">

  <BgVideo
    id="slide04"
    name="footer.mp4"/>

  <div id="slide04" class="section">

    <div>

      <div class="info-block">

        <Subtitle :text="$t('home.slide04.title')"/>

        <SmallCommon :text="$t('home.slide04.text')"/>

        <S04Contact
          :title="$t('home.slide04.contact01.title')"
          :text="$t('home.slide04.contact01.text')"
          :button="$t('home.slide04.contact01.button')"
          href="mailto:hi@flooyd.com"/>

        <S04Contact
          :title="$t('home.slide04.contact02.title')"
          :text="$t('home.slide04.contact02.text')"
          :button="$t('home.slide04.contact02.button')"
          href="mailto:talent@flooyd.com"/>

      </div>

      <div class="arrow-block">
        <Arrow
          type="up"
          toType="page"
          toId="#slide01"
          :text="$t('home.slide04.arrow')"/>
      </div>

    </div>

    <div class="footer">

      <div class="footer-left">
        <Fimage name="logo.svg"/>
      </div>

      <div class="footer-right">
        &#169; Flooyd 2020
      </div>

    </div>

  </div>

</div>

</template>

<script>
import Subtitle from '../general/texts/Subtitle.vue'
import SmallCommon from '../general/texts/SmallCommon.vue'
import BgVideo from '../general/elements/BgVideo.vue'
import Fimage from '../general/elements/Fimage.vue'
import Arrow from '../general/elements/Arrow.vue'
import S04Contact from './section04/S04Contact.vue'

export default {
  name: 'Slide04',
  components: {
    Subtitle,
    SmallCommon,
    Fimage,
    BgVideo,
    Arrow,
    S04Contact
  }
}
</script>

<style lang="scss" scoped>
.section {
  .info-block {
    width: 80%;
    display: inline-block;
  }

  .arrow-block {
    width: 9%;
    display: inline-block;
    margin-left: 10%;
  }

  .footer {
    padding: 150px 0 50px 0;

    .footer-left {
      max-width: 140px;
      display: inline-block;
      text-align: left;

      img {
        max-width: 140px;
      }
    }

    .footer-right {
      display: inline-block;
      float: right;
    }
  }
}

@media (max-width: 650px), (max-device-width: 650px) {
  .section {
    .info-block {
      width: 90%;
      display: block;
    }

    .arrow-block {
      width: 90%;
      display: block;
      margin: 100px auto;
    }

    .footer {
      padding: 50px 0;
    }
  }
}

@media (max-width: 450px), (max-device-width: 450px) {
  .section {
    .footer {
      .footer-left {
        display: block;
        margin-bottom: 20px;
      }

      .footer-right {
        display: block;
        float: none;
        text-align: left;
        margin-top: 20px;
      }
    }
  }
}
</style>
